<template>
    <div>
        <!--        <v-row class="px-3 my-1">
                    <v-col class="text-left" cols="12" md="8">
                        <div class="text-h5">
                            Information
                        </div>
                        <div class="subtitle-1 text-left mb-4">
                            View the access log and connected users
                        </div>
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="d-flex justify-end">
                            <v-text-field
                                ref="ruleSearch"
                                append-icon="mdi-magnify"
                                v-model="ruleFilterValue"
                                label="Narrow down rules"
                                clearable
                                v-if="isShowSearch && hideMobileListingForMobileIfListingItemSelected()"
                                class="search-listing-autocomplete max-width-450"
                            ></v-text-field>

                            <v-btn-toggle class="pr-2 my-1 ml-3 ">
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiMagnify"></v-icon>
                                </v-btn>
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiFilter"></v-icon>
                                </v-btn>
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiAccountPlus"></v-icon>
                                </v-btn>
                            </v-btn-toggle>

                        </div>

                    </v-col>
                </v-row>-->
        <v-row :class="{'information-tab-on-mob': $vuetify.breakpoint.xsOnly}">
            <v-col cols="12" lg="5" md="6">
                <v-tabs v-model="informationTabOptionsTab" class="mx-2" height="40">
                    <v-tab>
                        <v-icon class="mr-2" v-text="icons.mdiFilter"></v-icon>
                        {{ $gettext('Filter Log') }}
                    </v-tab>
                    <v-tab>
                        <v-icon class="mr-2">{{ icons.mdiAccountGroup }}</v-icon>
                        {{ $gettext('Connected Users') }}
                    </v-tab>
<!--                        v-if="['ftp only', 'support'].includes(loginMode) || currentConnection.value.type.toLowerCase() === 'ftp'"-->
                    <v-tab
                    >
                        <v-icon class="mr-2">{{ icons.mdiApplicationCogOutline }}</v-icon>
                        {{ $gettext('System') }}
                    </v-tab>
                    <!-- Temporarily Disabled -->
                    <!--            <v-tab>-->
                    <!--                <v-icon class="mr-2">{{ icons.mdiHeadQuestion }}</v-icon>-->
                    <!--                Why?-->
                    <!--            </v-tab>-->
                    <!-- Temporarily Disabled -->
                    <!-- search is temporarily disabled  <v-tab>
                                            <v-icon class="mr-2">{{ icons.mdiTextBoxSearch }}</v-icon>
                                            Search
                                        </v-tab>-->
                </v-tabs>
            </v-col>

            <v-col cols="12" lg="7" md="6">
                <v-spacer></v-spacer>
                <v-row v-if="informationTabOptionsTab === 0">
                    <!--                    <v-col cols="12" md="4">
                                            <v-autocomplete
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                clearable
                                            ></v-autocomplete>
                                        </v-col>-->

                    <v-col cols="12" md="12">
                        <v-row class="text-right mx-2">
                            <v-col cols="12" lg="3" md="6">
                                <!--                                    v-if="showInformationFilterSearch"-->
                                <v-text-field
                                    v-show="filterLogView === 'datatable'"
                                    v-model="internetFilterGeneralFilterValue"
                                    :label="$gettext('Search')"
                                    append-icon="mdi-magnify"
                                    clearable
                                    type="text"
                                ></v-text-field>
                            </v-col>

                            <!--                                    v-if="showInformationFilter"-->
                            <v-col cols="12" lg="3" md="6">
                                <v-select
                                    v-show="filterLogView === 'datatable'"
                                    v-model="statusFilterValue"
                                    :items="selectedAccess"
                                    :label="$gettext('Select Access')"
                                >
                                    <!--                                            :prepend-icon="icons.mdiCircleSmall"-->
                                </v-select>
                            </v-col>
                            <v-col
                                :class="{'justify-center': $vuetify.breakpoint.smAndDown, 'justify-end': $vuetify.breakpoint.mdOnly}"
                                class="d-flex" cols="12"
                                lg="4">

                                <!--                                <v-btn-toggle class="pr-2 my-1">
                                                                    <v-btn @click="toggleShowInformationFilterSearch()">
                                                                        <v-icon v-text="showInformationFilterSearch ? icons.mdiClipboardTextSearch : icons.mdiClipboardTextSearchOutline"></v-icon>
                                                                    </v-btn>
                                                                </v-btn-toggle>

                                                                <v-btn-toggle class="pr-2 my-1">
                                                                    <v-btn @click="toggleShowInformationFilter()">
                                                                        <v-icon v-text="showInformationFilter ? icons.mdiFilterMultiple : icons.mdiFilterMultipleOutline"></v-icon>
                                                                    </v-btn>
                                                                </v-btn-toggle>-->


                                <v-btn-toggle v-model="filterLogView" class="mr-6 mt-2" dense>
                                    <v-btn value="datatable" @click="toggleFilterLogView()">
                                        <span class="mr-2">{{ $gettext('Grid') }}</span>
                                        <v-icon v-text="icons.mdiTableLarge"></v-icon>
                                    </v-btn>
                                    <v-btn value="raw" @click="toggleFilterLogView()">
                                        <span class="mr-2">{{ $gettext('Text') }}</span>
                                        <v-icon v-text="icons.mdiTextBoxOutline"></v-icon>
                                    </v-btn>
                                </v-btn-toggle>

                                <v-btn-toggle class="mt-2" dense>
                                    <v-btn plain @click="refresh()">
                                        <v-icon :title="$gettext('Refresh')" v-text="icons.mdiRefresh"></v-icon>
                                    </v-btn>
                                </v-btn-toggle>

                            </v-col>
                        </v-row>
                        <!--                        <v-btn-toggle class="hidden-xs-only"
                                                              borderless
                                                >
                                                    <v-btn value="left">
                                                        <v-badge
                                                            bordered
                                                            inline
                                                            dot
                                                            color="blue"
                                                            class="ml-0"
                                                        >
                                                        </v-badge>
                                                        <span>All</span>
                                                    </v-btn>

                                                    <v-btn value="left">
                                                        <v-badge
                                                            bordered
                                                            inline
                                                            dot
                                                            color="green"
                                                            class="ml-0"
                                                        >
                                                        </v-badge>
                                                        <span>Allowed</span>
                                                    </v-btn>

                                                    <v-btn value="center">
                                                        <v-badge
                                                            bordered
                                                            inline
                                                            dot
                                                            color="orange"
                                                            class="ml-0"
                                                        >
                                                        </v-badge>
                                                        <span>Denied</span>
                                                    </v-btn>

                                                    <v-btn value="right">
                                                        <v-badge
                                                            bordered
                                                            inline
                                                            dot
                                                            color="yellow"
                                                            class="ml-0"
                                                        >
                                                        </v-badge>
                                                        <span>No Match</span>
                                                    </v-btn>

                                                    <v-btn value="justify">
                                                        <v-badge
                                                            bordered
                                                            inline
                                                            dot
                                                            color="red"
                                                            class="ml-0"
                                                        >
                                                        </v-badge>
                                                        <span>Blocked</span>
                                                    </v-btn>

                                                </v-btn-toggle>-->
                    </v-col>
                </v-row>
                <v-row v-else-if="informationTabOptionsTab === 1">
                    <v-col cols="12" md="12">
                        <v-row class="text-right mx-2">
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="connectedUsersIpFilterValue"
                                    :label="$gettext('IP Address')"
                                    append-icon="mdi-magnify"
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="connectedUsersMacFilterValue"
                                    :label="$gettext('Mac')"
                                    append-icon="mdi-magnify"
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="5">
                                <v-row>
                                    <v-col cols="9" lg="9" md="8" sm="10" xl="10">
                                        <v-select
                                            v-model="connectedUsersStatusFilterValue"
                                            :items="connectedUsersStatusFilterOptions"
                                            :label="$gettext('Status')"
                                            append-icon="mdi-toggle-switch-outline"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="3" lg="3" sm="2" xl="2">
                                        <v-btn-toggle class="mt-2" dense>
                                            <v-btn plain @click="refresh()">
                                                <v-icon :title="$gettext('Refresh')" v-text="icons.mdiRefresh"></v-icon>
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

            </v-col>
        </v-row>


        <v-tabs-items v-model="informationTabOptionsTab">

            <!-- FILTER TAB STARTS HERE -->
            <v-tab-item>
                <div>
                    <v-row class="my-4">

                        <v-col
                            :class="{'filter-tab-dns-table-on-mob': $vuetify.breakpoint.smAndDown , 'filter-tab-dns-table' : $vuetify.breakpoint.mdAndUp}"
                            class="pt-0"
                            cols="12">

                            <!--                            height="400"-->
                            <!--                            :search="search"-->
                            <!--                            :server-items-length="isNaN(unboundLog.length) ? 0 : unboundLog.length"-->
                            <!--                            :search="search"-->
                            <!--                            :items-per-page="-1"-->
                            <!--                            :hide-default-footer="true"-->

                            <!--                            :items-per-page="-1"-->

                            <v-data-table

                                v-if="filterLogView === 'datatable'"

                                v-model="internetFilterSelectedItem"

                                :footer-props="{
                                               showFirstLastPage: true,
                                               'items-per-page-text':$gettext('Rows per page'),
                                               'items-per-page-options': [10, 25, 50, 100, 200, -1],
                                               'show-first-last-page': false,
                                          }"
                                :headers="filterTabHeaders"
                                :items="unboundLogJson"

                                :items-per-page="-1"
                                :loading="informationProgressBar"

                                :loading-text="$gettext('Just a moment, loading the filter log.')"
                                :sort-by="'dateAndTime'"

                                :sort-desc="true"

                                checkbox-color="primary"

                                class="filter-tab-dns-table"
                                fixed-header

                                item-key="index"


                            >
                                <template v-slot:footer.page-text>
                                    <div class="d-flex justify-space-between align-center">
                                        <div>
                                            {{ $gettext('User details') }}
                                        </div>
                                        <v-switch
                                            v-model="showAdditionalUserDetails"
                                            :false-value="false"
                                            :true-value="true"
                                            class="pl-2"
                                            color="primary"
                                            @change="updateShowAdditionalUserDetails()"
                                        ></v-switch>
                                    </div>
                                </template>
                                <!--<template v-slot:top v-if="showInformationFilterSearch">
                                    <v-text-field
                                        v-model="search"
                                        label="Search"
                                        class="mx-4"
                                    ></v-text-field>
                                </template>-->
                                <template v-slot:header.dateAndTime="{ header }">
                                    <v-icon class="mr-2" small>{{ icons.mdiClockOutline }}</v-icon>
                                    <span class="font-weight-bold" v-text="header.text"></span>
                                </template>
                                <template v-slot:header.status="{ header }">
                                    <v-icon class="mr-2" small>{{ icons.mdiAccessPoint }}</v-icon>
                                    <span class="font-weight-bold" v-text="header.text"></span>
                                </template>
                                <template v-slot:header.domain="{ header }">
                                    <v-icon class="mr-2" small>{{ icons.mdiWeb }}</v-icon>
                                    <span class="font-weight-bold" v-text="header.text"></span>
                                </template>
                                <template v-slot:header.user="{ header }">
                                    <v-icon class="mr-2" small>{{ icons.mdiAccount }}</v-icon>
                                    <span class="font-weight-bold" v-text="header.text"></span>
                                </template>
                                <template v-slot:header.rule="{ header }">
                                    <v-icon class="mr-2" small>{{ icons.mdiDns }}</v-icon>
                                    <span class="font-weight-bold" v-text="header.text"></span>
                                </template>
                                <template v-slot:header.actions="{ header }">
                                    <span class="font-weight-bold" v-text="header.text"></span>
                                </template>

                                <template v-slot:item.dateAndTime="{ item }">
                                    {{ item.dateAndTime | capitalize }}
                                </template>

                                <template v-slot:item.status="{ item }">
                                    <v-chip :color="colorForStatus(item.status)" class="white--text elevation-1" small>
                                        <!--                                    <v-badge
                                                                                bordered
                                                                                inline
                                                                                dot
                                                                                :color="colorForStatus(item.status)"
                                                                                class="ml-0"
                                                                                v-if="colorForStatus(item.status)"
                                                                            ></v-badge>-->
                                        {{ item.status }}
                                    </v-chip>
                                </template>
                                <template v-slot:item.user="{ item }">

                                    <div v-if="!showAdditionalUserDetails">
                                        {{ item.user | removeParenthesis | trim }}
                                    </div>
                                    <div v-else-if="item.user.indexOf('()') !== -1">
                                        {{ item.ip | removeParenthesis | trim | capitalize }}
                                    </div>
                                    <div v-else>
                                        {{ item.user + '/ ' + item.ip | removeParenthesis | trim | capitalize }}
                                    </div>
                                </template>

                                <template v-slot:item.rule="{ item }">
                                    <div :class="colorForStatus(item.status) + '--text'" class="mw-150"
                                         v-text="displayManipulationForRuleName(item.rule)"></div>
                                </template>

                                <template v-slot:item.domain="{ item }">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <a class="mw-150 font-weight-bold"
                                               v-bind="attrs"
                                               @click="openAddRuleFromFilterAndAssignDomainToGroupDialog(item)"
                                               v-on="on"
                                               v-text="item.domain"></a>
                                        </template>
                                        <span>{{ $gettext('Add to rule/group') }}</span>
                                    </v-tooltip>
                                </template>

                                <template v-slot:item.actions="{ item }">

                                    <v-btn
                                        :class="{'show-on-hover': $vuetify.breakpoint.smAndUp, 'mb-2': $vuetify.breakpoint.xsOnly }"
                                        color="primary"
                                        rounded
                                        small @click="openAddRuleFromFilterAndAssignDomainToGroupDialog(item)">
                                        <v-icon class="mr-2">{{ icons.mdiWebPlus }}</v-icon>
                                        {{ $gettext('Add to Rule/Group') }}
                                    </v-btn>

                                </template>
                                <template v-slot:item.actions="{ item }" class="text-right">
                                    <v-menu>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="ml-auto d-flex" icon v-bind="attrs" v-on="on">
                                                <v-icon
                                                    v-text="$vuetify.breakpoint.mdAndUp ? icons.mdiDotsVertical : icons.mdiDotsHorizontal"></v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item class="cursor-pointer"
                                                         @click="openAddRuleFromFilterAndAssignDomainToGroupDialog(item)">
                                                <v-list-item-title>
                                                    <v-btn class="mr-1" icon>
                                                        <v-icon color="secondary" v-text="icons.mdiPlus"></v-icon>
                                                    </v-btn>
                                                    {{ $gettext('Add to Rule/Group') }}
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-data-table>
                            <v-textarea
                                v-else-if="filterLogView === 'raw'"
                                v-model="unboundLogTxt"
                                auto-grow
                                class="mx-3"
                                label="Log"
                                readonly
                                rows="10"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </div>
            </v-tab-item>

            <!-- FILTER TAB ENDS HERE -->

            <!-- CONNECTED TAB STARTS HERE -->
            <v-tab-item>
                <div>
                    <connected-users
                        :params="{connectedUsersIpFilterValue, connectedUsersMacFilterValue, connectedUsersStatusFilterValue}"></connected-users>
                </div>
            </v-tab-item>
            <!-- CONNECTED TAB ENDS HERE -->

<!--                v-if="['ftp only', 'support'].includes(loginMode) || currentConnection.value.type.toLowerCase() === 'ftp'"-->
            <v-tab-item>
                <system></system>
            </v-tab-item>

        </v-tabs-items>


        <!------------------------------------------------
            Dialogs
        ------------------------------------------------->

        <add-rule-from-filter-and-assign-domain-to-group
            v-if="addRuleFromFilterAndAssignDomainToGroupDialog"
            :params="addRuleFromFilterAndAssignDomainToGroupParams"></add-rule-from-filter-and-assign-domain-to-group>

        <snackbar ref="snackbar"></snackbar>

    </div>

</template>


<script>
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import draggable from 'vuedraggable'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinConfig from '@/mixins/database/MixinConfig'
import DialogInformationAddRuleFromFilterAndAssignDomainToGroup
    from './dialogs/informations_tab/DialogInformationAddRuleFromFilterAndAssignDomainToGroup'
import MixinConfigInformation from '../mixins/database/MixinConfigInformation'
import MixinDialog from '../mixins/MixinDialog'
import ConnectedUsers from '@/components/tabs/information/ConnectedUsers'
import {mapState, mapWritableState} from 'pinia'
import {useConnectionsStore} from '@/stores/ConnectionsStore'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import {isEqual, uniqWith} from 'lodash'
import {useInformationStore} from '@/stores/InformationStore'
import System from "@/components/tabs/information/System.vue";
import {useLoginStore} from "@/stores/LoginStore";
import MixinGenericLocalStorage from "@/mixins/MixinGenericLocalStorage";

Vue.use(VueSweetalert2)

export default {
    name: 'informationTabOptionsTab',
    components: {
        System,
        draggable,
        Snackbar,
        'add-rule-from-filter-and-assign-domain-to-group': DialogInformationAddRuleFromFilterAndAssignDomainToGroup,
        ConnectedUsers,
    },
    mixins: [MixinIcon, MixinConfigInformation, MixinDialog, MixinStringManipulation, MixinGenericLocalStorage],
    data() {
        return {

            /* expected values: datatable, and raw */
            filterLogView: 'datatable',

            connectedUsersIpFilterValue: '',
            connectedUsersMacFilterValue: '',
            connectedUsersStatusFilterValue: '',

            internetFilterGeneralFilterValue: '',
            statusFilterValue: 'All',

            internetFilterSelectedItem: [],
            selectedAccessModel: [],
            selectedAccess: ['All', 'Allowed', 'Denied', 'No Match', 'Blocked'],
            // showInternetFilter: false,
            // showInternetFilterSearch: false,
            showInformationFilter: false,
            showInformationFilterSearch: false,
            addRuleFromFilterAndAssignDomainToGroupDialog: '',
            addRuleFromFilterAndAssignDomainToGroupParams: '',
            informationTabOptionsTab: '',
            filterTab: '',
            search: '',
            searchTabSearch: '',
            singleSelect: false,
            radioGroup: 1,
            filterTabHeaders: [
                {text: this.$gettext('Access'), value: 'status', filter: this.statusFilter},
                {text: this.$gettext('Reason'), value: 'rule'},
                {text: this.$gettext('Domain'), value: 'domain', filter: this.internetFilterGeneralFilter},

                /* {
                    text: 'Date',
                    align: 'start',
                    value: 'dateAndTime',
                    /!*filter: this.internetFilterGeneralFilter*!/
                },
                {
                    text: 'Time',
                    align: 'start',
                    value: 'dateAndTime',
                    /!*filter: this.internetFilterGeneralFilter*!/
                },*/
                {text: this.$gettext('User'), value: 'user'},
                {
                    text: this.$gettext('Date & Time'),
                    align: 'start',
                    value: 'dateAndTime',
                    /*filter: this.internetFilterGeneralFilter*/
                },
                {
                    text: this.$vuetify.breakpoint.smAndDown ? this.$gettext('Actions') : '',
                    value: 'actions',
                    sortable: false
                },
            ],
            showAdditionalUserDetails: false,
        }
    },
    computed: {

        ...mapState(useConnectionsStore, {
            currentConnection: 'currentConnection',
        }),
        ...mapState(useInformationStore, {
            unboundLogJson: 'unboundLogJson',
            unboundLogTxt: 'unboundLogTxt',
            connectedUsersStatusFilterOptions: 'connectedUsersStatusFilterOptions',
        }),
        ...mapWritableState(useInformationStore, {
            informationProgressBar: 'informationProgressBar',
        }),
        ...mapState(useLoginStore, {
            loginMode: 'loginMode',
        })

    },
    methods: {

        displayManipulationForRuleName(ruleName) {

            ruleName = ruleName.replace('allowed by', '')
            ruleName = ruleName.trim()

            return ruleName
        },

        refresh() {

            let self = this

            useInformationStore().$reset()
            self.$refs.snackbar.showSnackbar(self.$gettext('Refreshing... Just a moment.'), 'info')
            self.configLoadInformationAndSetInStores()

        },

        toggleFilterLogView() {
            this.filterLogView = (this.filterLogView === 'datatable') ? 'raw' : 'datatable'
        },

        colorForStatus(status) {

            if (status.toLowerCase().includes('allowed')) {
                return 'secondary'
            } else if (status.toLowerCase().includes('blocked')) {
                return 'red'
            } else if (status.toLowerCase().includes('denied')) {
                return 'orange'
            } else if (status.toLowerCase().includes('no match')) {
                return 'yellow'
            }

            return 'grey'

        },

        internetFilterGeneralFilter(value) {

            // If this filter has no value we just skip the entire filter.
            if (!this.internetFilterGeneralFilterValue) {
                return true
            }

            if (value) {
                // partially contains the searched word.
                return value.toLowerCase().includes(this.internetFilterGeneralFilterValue.toLowerCase())
            }

            return value

        },

        statusFilter(value) {
            // If this filter has no value we just skip the entire filter.
            if (!this.statusFilterValue || this.statusFilterValue.toLowerCase() === 'all') {
                return true
            }
            // partially contains the searched word.
            return value.trim().toLowerCase() === (this.statusFilterValue.trim().toLowerCase())
        },

        /*   toggleShowInternetFilterOnMobile() {
               let self = this;

               self.showInternetFilterOnMobile = ! self.showInternetFilterOnMobile;
           },*/


        toggleShowInformationFilter() {
            let self = this

            self.showInformationFilter = !self.showInformationFilter
        },

        toggleShowInformationFilterSearch() {
            let self = this

            self.showInformationFilterSearch = !self.showInformationFilterSearch
        },

        openAddRuleFromFilterAndAssignDomainToGroupDialog(item) {

            let self = this

            self.addRuleFromFilterAndAssignDomainToGroupDialog = true
            self.setFieldsForAddRuleFromFilterAndAssignDomainToGroupDialog(item)

        },

        setFieldsForAddRuleFromFilterAndAssignDomainToGroupDialog(item) {
            let self = this
            self.addRuleFromFilterAndAssignDomainToGroupParams = {
                addRuleFromFilterAndAssignDomainToGroupDialog: self.addRuleFromFilterAndAssignDomainToGroupDialog,
                item: item
            }
        },

        updateShowAdditionalUserDetails() {

            let self = this

            // I noticed an empty array was set, so we are being careful here.
            if (typeof self.showAdditionalUserDetails === 'boolean') {
                self.genericLocalStorageSetItem('informations.filterLog.userDetails', self.showAdditionalUserDetails)
            }

        },

    },

    async mounted() {

        let self = this;


        try {

            if (self.genericLocalStorageHasItem('informations.filterLog.userDetails')) {

                let userDetails = await self.genericLocalStorageGetItem('informations.filterLog.userDetails')

                // I noticed an empty array was set, so we are being careful here.
                if (typeof userDetails === 'boolean') {
                    self.showAdditionalUserDetails = userDetails
                }

            }

        } catch (e) {
            console.error(e)
        }

    },
}
</script>

<style type="text/scss">

.mw-150 {
    max-width: 150px;
}

.mw-200 {
    max-width: 200px;
}

.filter-tab-dns-table th.text-start, .search-tab-table th.text-start {
    font-size: 14px !important;
    //text-transform: uppercase; font-weight: 500;
}

.filter-tab-dns-table-on-mob th.text-start {
    font-size: 12px !important;
}

/*
.filter-tab-dns-table .v-input.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--column {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
}

.filter-tab-dns-table td.text-start, .search-tab-table td.text-start {
    font-size: 13px !important;
    height: 23px !important;
}

.information-tab-on-mob .v-slide-group__prev.v-slide-group__prev--disabled, .v-slide-group__next, .v-slide-group__prev {
    min-width: 0;
    flex: none;
}*/

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr .show-on-hover {
    visibility: hidden;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) .show-on-hover {
    visibility: visible;
}

</style>
